var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94716 0.321197C4.10968 1.40015 1.64951 4.71779 0.509804 9.00221C-0.112699 11.3416 -0.177133 15.4249 0.382881 17.0328C1.30053 19.6664 3.07203 20.9939 5.67513 20.9978C8.79326 21.0028 10.4506 19.444 14.1644 13.0134C16.2652 9.37572 15.7312 9.27049 18.4793 13.8633C21.8336 19.4689 23.5495 21 26.4778 21C27.2837 21 28.2861 20.8554 28.7107 20.6776C29.8215 20.2129 30.9372 18.9629 31.492 17.5618C32.1718 15.8453 32.1688 11.3214 31.4862 8.7662C29.7452 2.24959 24.9612 -1.42055 20.7337 0.517587C19.8623 0.91708 19.0117 1.57922 17.9511 2.68351L16.4235 4.2739L15.0179 2.82685C13.1305 0.883952 11.5888 0.123724 9.39803 0.0559508C8.38547 0.0245543 7.46501 0.124157 6.94716 0.321197ZM21.3983 2.93403C20.5936 3.35107 19.3023 4.5935 18.5626 5.66228L18.0037 6.47036L19.8757 9.53401C24.7591 17.5256 25.7223 18.4913 27.7585 17.4368C28.8708 16.8609 29.146 15.8622 29.0089 12.8971C28.9425 11.4587 28.7263 9.69727 28.5285 8.98273C27.234 4.3092 24.0146 1.57792 21.3983 2.93403ZM8.13876 3.48618C5.69372 4.2083 3.34382 9.15075 3.34382 13.5714C3.34382 15.6364 3.65389 16.5872 4.56094 17.3039C5.29609 17.8846 6.64466 17.8391 7.48425 17.2049C8.46677 16.4627 10.9118 13.0316 13.8418 8.28356L14.407 7.36787L13.383 6.06264C12.3605 4.75958 10.7094 3.46388 10.0638 3.45825C9.87588 3.45673 9.52777 3.41451 9.28992 3.36471C9.05208 3.31491 8.53401 3.36947 8.13876 3.48618Z",
    fill: "url(#paint0_radial_797_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_797_10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3548 21) rotate(-66.1356) scale(22.9632 29.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564246,
    stopColor: "#96C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8ECF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.a421e949b858a184afe5f92631bd0b52.svg";
export { ForwardRef as ReactComponent };